module.exports = __webpack_public_path__ + "static/media/S2N1-4.71a9a26b.svg";